import { Stack } from "expo-router";
import { useUnistyles } from "react-native-unistyles";
import { AlarmSettings } from "@src/features/alarms/screens/AlarmSettings";
import { useCameraRouteParams } from "@src/hooks/useCameraRouteParams";
import { useCameraPermissions } from "@visioni/a3s-access/app";

export default function CameraAlarmScreen() {
  const { cameraKey, siteId: effectiveSiteId } = useCameraRouteParams({
    requireSiteId: true,
    requireCameraKey: false,
  });

  return <MobileAlarmScreen cameraKey={cameraKey} siteId={effectiveSiteId} />;
}

function MobileAlarmScreen({ cameraKey, siteId }: { cameraKey?: string; siteId?: string }) {
  const { theme } = useUnistyles();
  const { canManageAlarmSchedules } = useCameraPermissions(siteId ?? "", cameraKey ?? "");

  return (
    <>
      <Stack.Screen
        options={{
          title: "Alarm Settings",
          headerStyle: {
            backgroundColor: theme.colors.background,
          },
          headerTintColor: theme.colors.text,
          headerBackButtonDisplayMode: "minimal",
        }}
      />
      <AlarmSettings
        cameraKey={cameraKey}
        siteId={siteId}
        showCameraSelection={false}
        readOnly={!canManageAlarmSchedules}
      />
    </>
  );
}
